<div class="w-full h-full">
    <!-- Tab Header with Refresh & Print Buttons -->
    <div class="flex items-center justify-between space-x-3 pt-6 pl-8 pb-5 text-sm">
        <div class="flex items-center space-x-3 text-xs mb-2">
            <button
                class="custom-tabbtn focus:outline-none py-2 px-10 uppercase font-semibold"
                [class.btn-dark-orange]="activeAdType === 'screen'"
                [class.btn-light-orange]="activeAdType !== 'screen'"
                (click)="setActiveTab('screen')">
                Screen
            </button>
            <button
                class="custom-tabbtn focus:outline-none py-2 px-10 uppercase font-semibold"
                [class.btn-dark-orange]="activeAdType === 'link'"
                [class.btn-light-orange]="activeAdType !== 'link'"
                (click)="setActiveTab('link')">
               Link
            </button>
        </div>
        <div class="flex items-center space-x-3">
            <span 
                class="material-icons text-black text-opacity-50 cursor-pointer text-2xl"
                matTooltip="Refresh"
                matTooltipClass="custom-orange-tooltip"
                matTooltipPosition="left"
                (click)="refresh()">
                refresh
            </span>
            <app-print-button       
                matTooltip="Export to Excel" 
                matTooltipPosition="left" 
                matTooltipClass="custom-orange-tooltip"
                (click)="print()" 
            >
            </app-print-button>
        </div>
    </div>

    <div class="flex flex-row gap-4 px-8">  
        <div class="flex items-center">
            <app-toggle-add-btn
                label="Create Ads"
                icon="add_circle"
                [textSize]="'text-base'"
                [fontWeight]="'font-bold'"
                (clicked)="openCreateModal()"
            />
        </div>
    </div>

    <!-- Table Controls (Search & Limit) -->
    <app-table-controls
        #tableControls
        [currentLimit]="size"
        [searchPlaceholder]="'Search ads'"
        (limitChangeEvent)="onLimitChangeFromComponent($event)"
        (searchKeyupEvent)="onSearchKeyupFromComponent($event)"
        (keydownEvent)="keyDownFunction($event)"
        marginTop="mt-4"
    ></app-table-controls>

    <!-- Data Table — headers switch automatically with the active tab -->
    <app-data-table
        [tableHeader]="tableHeader"
        [tableSubHeader]="tableSubHeader"
        [isLoading]="isLoading"
        [sort_type]="sort_type"
        (toggleOnSort)="sortList($event.key, $event.type)"
    >
        <tr class="focus:outline-none" *ngFor="let ads_lists of ads_list">
            <td class="text-center">{{ ads_lists.title }}</td>
            <td class="text-center">
                <div class="flex justify-center">
                    <a [href]="ads_lists.imageUrl">
                        <img [src]="ads_lists.imageUrl" style="width:100px">
                    </a>
                </div>
            </td>
            <td class="text-center" *ngIf="activeAdType === 'screen'">
                <p *ngIf="ads_lists.screen === '1'">Cash-In</p>
                <p *ngIf="ads_lists.screen === '7'">Buy Load</p>
                <p *ngIf="ads_lists.screen === '8'">Pay Bills</p>
                <p *ngIf="ads_lists.screen === '10'">Redeem</p>
                <p *ngIf="ads_lists.screen === '11'">Purchase</p>
                <p *ngIf="ads_lists.screen === null">N/A</p>
            </td>
            <td class="text-center" *ngIf="activeAdType === 'link'">
                <p *ngIf="ads_lists.link">
                    <a [href]="ads_lists.link">{{ ads_lists.link }}</a>
                </p>
            </td>
            <td class="text-center">{{ ads_lists.placement || 'NO PLACEMENT' }}</td>
            <!-- <td class="text-center" *ngIf="activeAdType === 'link'">
                <p *ngIf="ads_lists.status === '0'">Active</p>
                <p *ngIf="ads_lists.status !== '0'">Inactive</p>
            </td> -->
            <td class="text-center">{{ ads_lists.priority }}</td>
            <td class="text-center">{{ ads_lists.viewers || 0 }}</td>
            <td class="text-center">{{ ads_lists.createDate }}</td>
            <td class="text-center">{{ ads_lists.description }}</td>
            <td class="text-xs text-center">
                <div class="flex items-center justify-center space-x-3">
                    <ng-container *ngIf="ads_lists">
                        <button class="power-btn2" *ngIf="ads_lists.status === '1'" 
                                (click)="enable(ads_lists.uid)">
                            Disabled
                        </button>
                        <button class="power-btn2 active" *ngIf="ads_lists.status === '0'" 
                                (click)="disable(ads_lists.uid)">
                            Enabled 
                        </button>
                    </ng-container>
                    <button class="action-btn-blue2 custom-btn" (click)="openEditModal(ads_lists.uid)">
                        Edit
                    </button>
                </div>
            </td>
        </tr>
    </app-data-table>

    <!-- Pagination -->
    <app-pagination
        [currentPage]="current_page"
        [totalPages]="total_pages"
        [pageSize]="size"
        [totalItems]="total"
        (pageChange)="setPage($event)"
        (previousPage)="prevPage()"
        (nextPage)="nextPage()"
        [showTotalEntries]="true"
    ></app-pagination>
</div>

<ngx-spinner type="border" size="medium">
    <app-megapay-loader></app-megapay-loader>
</ngx-spinner>